import api from '../../index';

export const GetActiveBanner = (params) => api.get(`BannerMaster/GetActiveBanner?${params}`);